module.exports = {
      id: "comm-gadgets-usage",
      viewBox: "0 0 320 56.865",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-gadgets",
      toString: function () {
        return this.url;
      }
    }